export default function Logger(message, status, details, severity = 'Error', errorType = "ClientSide", logLevel = 5) {
    window.logger.failed({message: message, status: status, details: details, severity, errorType, logLevel});
}